import { useMemo, useCallback } from 'react';
import PropTypes from 'prop-types';

import { noop } from 'utils';

export const ObfuscateLink = ({ children, href, onClick = noop, ...props }) => {
	const clickHandler = useCallback(
		(event) => {
			event.preventDefault();
			window.location.href = href;
			onClick(event);
		},
		[onClick, href]
	);
	const protocol = useMemo(() => href.split(':')[0], [href]);

	return (
		<a onClick={clickHandler} href={`${protocol}:obfuscated`} {...props}>
			{children}
		</a>
	);
};

ObfuscateLink.propTypes = {
	onClick: PropTypes.func,
	href: PropTypes.string.isRequired,
};
